import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';
import { QRCodeSVG } from 'qrcode.react';
import { Copy } from 'lucide-react';

function History() {
    const [vouchers, setVouchers] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [copiedPin, setCopiedPin] = useState(false);

    const toggleExpand = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    useEffect(() => {
        const session = JSON.parse(sessionStorage.getItem('gbx_data'));
        if (session && session.user && session.user.vouchers) {
            setVouchers(session.user.vouchers);
            console.log(session.user.vouchers)
        }
    }, []);

    function addThirtyPercent(num) {
        const increased = num * 1.3;
        return Math.ceil(increased);
    }

    function parseLpaCode(code) {
        if (!code?.startsWith("LPA:1$")) {
            return { smdpAddress: null, activationCode: null, error: "Invalid format" };
        }

        const cleanedCode = code.replace("LPA:1$", "");
        const parts = cleanedCode.split("$");

        if (parts.length !== 2) {
            return { smdpAddress: null, activationCode: null, error: "Invalid format" };
        }

        return { smdpAddress: parts[0], activationCode: parts[1], error: null };
    }

    const handleCopyPin = (pinCode) => {
        if (pinCode) {
            navigator.clipboard.writeText(pinCode);
            setCopiedPin(true);
            setTimeout(() => setCopiedPin(false), 2000);
        }
    };

    return (
        <div>
            <Navbar />
            <section className="container" style={{ marginTop: '100px' }}>
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <h2>Voucher History</h2>
                </div>

                <div className="d-flex flex-column gap-4 mt-4">
                    {vouchers && vouchers.length > 0 ? (
                        vouchers.map((item, index) => {
                            const isEsim = item.product.service?.name?.toLowerCase() === 'esim';
                            const pinCode = item.pin?.code || item.product.pin?.code || '';
                            const esimDetails = isEsim ? parseLpaCode(pinCode) : null;

                            return (
                                <div key={item.id}>
                                    {/* Clickable Header */}
                                    <div
                                        className="bg-input d-flex flex-row justify-content-between align-items-center p-2 br_15"
                                        onClick={() => toggleExpand(index)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="d-flex flex-row align-items-center gap-2">
                                            <img
                                                style={{
                                                    width: "3rem",
                                                    height: "3rem",
                                                    objectFit: "contain",
                                                    borderRadius: "0.75rem",
                                                }}
                                                src={item.image}
                                                alt="Voucher"
                                            />
                                            <p className="text-dark bold">
                                                #{item.id} | {item.product.name}
                                            </p>
                                        </div>
                                        <p className="text-dark">
                                            {new Date(item.creation_date).toLocaleDateString("en-GB")}{" "}
                                            {new Date(item.creation_date).toLocaleTimeString("en-US", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </p>
                                    </div>

                                    {/* Expandable Section */}
                                    {expandedIndex === index && (
                                        <div className="p-3 mt-2 br_15">
                                            <table className="table table-bordered">
                                                <tbody>
                                                    <tr>
                                                        <td><b>ID</b></td>
                                                        <td>{item.id}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><b>Product</b></td>
                                                        <td>{item.product.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><b>Amount</b></td>
                                                        <td>{item.benefits[0]?.unit} {item.benefits[0]?.additional_information}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><b>Price</b></td>
                                                        <td>{item.prices.retail ? `${item.prices.retail.amount} ${item.prices.wholesale.unit}` : `${addThirtyPercent(item.prices.wholesale.amount)} ${item.prices.wholesale.unit}`}</td>
                                                    </tr>

                                                    {item.product.pin && (
                                                        <tr>
                                                            <td><b>Terms</b></td>
                                                            <td>
                                                                {item.product.pin.terms
                                                                    ? item.product.pin.terms.split("\n").map((line, i) => (
                                                                        <div key={i}>{line}</div>
                                                                    ))
                                                                    : item.product.pin.usage_info?.[0]}
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {/* eSIM QR Code or Regular Pin */}
                                                    {isEsim ? (
                                                        pinCode ? (
                                                            <tr>
                                                                <td><b>eSIM QR Code</b></td>
                                                                <td>
                                                                    <div style={{ marginBottom: '10px' }}>
                                                                        <QRCodeSVG value={pinCode} size={128} />
                                                                    </div>
                                                                    {esimDetails && !esimDetails.error && (
                                                                        <div style={{ marginBottom: '10px' }}>
                                                                            <div><b>SM-DP+ Address:</b> {esimDetails.smdpAddress}</div>
                                                                            <div><b>Activation Code:</b> {esimDetails.activationCode}</div>
                                                                        </div>
                                                                    )}
                                                                    <button
                                                                        onClick={() => handleCopyPin(esimDetails.activationCode)}
                                                                        style={{
                                                                            padding: '3px 7px',
                                                                            color: '#6d4eec',
                                                                            cursor: 'pointer',
                                                                            borderRadius: '4px',
                                                                            fontWeight: '700',
                                                                            fontSize: '1.2rem',
                                                                            border: '1px solid #ccc',
                                                                            backgroundColor: '#EFEBFF'
                                                                        }}
                                                                    >
                                                                        <Copy size={15} color="#6d4eec" /> Copy
                                                                    </button>

                                                                    {copiedPin && (
                                                                    <div style={{ color: 'green', fontSize: '12px' }}>
                                                                        Pin copied to clipboard!
                                                                    </div>
                                                                )}
                                                                </td>
                                                            </tr>
                                                        ) : null
                                                    ) : (
                                                        <tr>
                                                            <td style={{ padding: '20px 0px' }}><b>Pin Code</b></td>
                                                            <td style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '1rem' }}>
                                                                    <div>{pinCode}</div>
                                                                    {pinCode && (
                                                                        <button
                                                                            onClick={() => handleCopyPin(pinCode)}
                                                                            style={{
                                                                                padding: '3px 7px',
                                                                                color: '#6d4eec',
                                                                                cursor: 'pointer',
                                                                                borderRadius: '4px',
                                                                                fontWeight: '700',
                                                                                fontSize: '1.2rem',
                                                                                border: '1px solid #ccc',
                                                                                backgroundColor: '#EFEBFF'
                                                                            }}
                                                                        >
                                                                            <Copy size={15} color="#6d4eec" /> Copy
                                                                        </button>
                                                                    )}
                                                                </div>
                                                                {copiedPin && (
                                                                    <div style={{ color: 'green', fontSize: '12px' }}>
                                                                        Pin copied to clipboard!
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    ) : (
                        <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ padding: "2rem" }}>
                            <h3 className="text-dark">No Vouchers Found</h3>
                            <p className="text-muted">
                                You don't have any vouchers at the moment. Browse our store to get amazing deals!
                            </p>
                        </div>
                    )}
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default History;
